import { useParams } from "react-router-dom";
import AgentShowRenderer from "~/components/agent/AgentShowRenderer";
import { CommandJob } from "~/components/build/Show/lib/types";
import { AgentIcon } from "~/components/job/Job/Agent";
import Icon from "~/components/shared/Icon";
import Spinner from "~/components/shared/Spinner";

export const AgentTabLabel = ({ job }: { job: CommandJob }) => {
  return (
    <span className="flex gap-1">
      {job.agentUuid ? (
        <AgentIcon os={job.instanceShape?.operatingSystem} />
      ) : (
        <Icon icon="custom/outline/14x/queue" className="h-3.5 w-3.5 flex-shrink-0" />
      )}

      <span>Agent</span>
    </span>
  );
};

export default function AgentTab({ job }: { job: CommandJob }) {
  const { org = "" } = useParams<{ org: string }>();

  if (job.agentUuid) {
    return (
      <div className="py-2.5">
        <AgentShowRenderer params={{ agent: job.agentUuid, organization: org }} />
      </div>
    );
  }

  if (job.agentsPath) {
    return (
      <div className="py-2.5">
        <span className="flex items-center gap-2">
          <Spinner color={false} />
          <a href={job.agentsPath} className="text-inherit hover:text-inherit">
            {job.clusterQueue?.key ? (
              <span className="inline-flex gap-1">
                Waiting for agent in queue:
                <span className="font-medium">{job.clusterQueue?.key}</span>
              </span>
            ) : (
              <span className="hover:underline">Waiting for agent</span>
            )}
          </a>
        </span>
      </div>
    );
  }

  return null;
}
